export function safeReturnTo(value, role) {
  if (typeof value !== 'string' || !value.startsWith('/') || /^\/[/\\]/.test(value) || /[\\\r\n]/.test(value)) return null;
  const pathname = value.split(/[?#]/)[0];
  if (/^\/(login|register|forgot-password|reset-password)(\/|$)/.test(pathname)) return null;
  if (/^\/admin(\/|$)/.test(pathname) && role !== 'admin') return null;
  return value;
}
